import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'default' | 'good' | 'warning' | 'critical' | 'neutral' | 'accent';
  to?: string;
  icon?: ReactNode;
}

/** Stat tile: label, value (proportional figures), optional hint. */
export function StatTile({ label, value, hint, tone = 'default', to, icon }: Props) {
  const className = `stat${tone !== 'default' ? ` stat--${tone}` : ''}`;
  const body = (
    <>
      <div className="stat__label">
        {icon}
        {label}
      </div>
      <div className="stat__value">{value}</div>
      {hint ? <div className="stat__hint">{hint}</div> : null}
    </>
  );
  return to ? (
    <Link to={to} className={className}>
      {body}
    </Link>
  ) : (
    <div className={className}>{body}</div>
  );
}

export function StatRow({ children }: { children: ReactNode }) {
  return <div className="stat-row">{children}</div>;
}
